/**
 * @param {CtaIconApiType}
 * @return {IconType | undefined}
 */
const getCtaIcon = (ctaIcon) => {
  if (ctaIcon === 'NONE') return undefined;
  return ctaIcon;
};

export default getCtaIcon;
